import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { Input, Button, Card } from "../../components/common";
import { isCurrentUserAdmin } from "./LoginApi";
import axiosInstance from "../../api/axiosInstance";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const token = await userCredential.user.getIdToken();

      localStorage.setItem("authToken", token);
      axiosInstance.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${token}`;

      const isAdmin = await isCurrentUserAdmin(); // 🌟 admin kontrolü

      console.log("Kullanıcı admin mi?", isAdmin);

      if (!isAdmin) {
        // ⛔ Token'ı sil ve oturum bilgilerini sıfırla
        localStorage.removeItem("authToken");
        delete axiosInstance.defaults.headers.common["Authorization"];

        alert("Bu alana yalnızca admin kullanıcılar giriş yapabilir.");
        return;
      }

      navigate("/dashboard");
    } catch (err: unknown) {
      const errorMessage =
        err instanceof Error ? err.message : "Bilinmeyen bir hata oluştu.";
      alert("Giriş başarısız: " + errorMessage);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'var(--bg-primary)',
      padding: 'var(--spacing-xl)'
    }}>
      <div style={{ width: '100%', maxWidth: '400px' }}>
        <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-2xl)' }}>
          <div style={{ fontSize: '3rem', marginBottom: 'var(--spacing-base)' }}><span role="img" aria-label="drum">🥁</span></div>
          <h1 style={{ marginBottom: 'var(--spacing-sm)' }}>Drumly</h1>
          <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--font-size-sm)' }}>Dashboard Login</p>
        </div>
        
        <Card>
          <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-lg)' }}>
            <Input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              label="Email"
            />
            <Input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              label="Password"
            />
            <Button type="submit" style={{ width: '100%' }}>
              Login
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default LoginPage;
